export enum FramePositionEnum {
    START = 'START',
    ACTIVE = 'ACTIVE',
}
